import { useCallback, useState } from 'react';

export function useDisabledMetricsBoxes<T = string>() {
  const [disabledMetrics, setDisabledMetrics] = useState<T[]>([]);

  const toggleMetric = useCallback((key: T) => {
    setDisabledMetrics((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  }, []);

  const isMetricDisabled = useCallback(
    (key: T) => disabledMetrics.includes(key),
    [disabledMetrics]
  );

  return { toggleMetric, isMetricDisabled };
}
